import { Component, OnInit, ChangeDetectorRef, ViewChild, Inject } from '@angular/core';
import { MatPaginator } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';
import { MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatSnackBar } from '@angular/material/snack-bar';

import { SearchMusicsService } from '../../providers/Import/searchMusics.service';
import { DataPassService } from '../../providers/Global/dataPass.service';

import { SelectionModel } from '@angular/cdk/collections';

@Component({
  selector: 'app-search-musics',
  templateUrl: './searchMusics.component.html',
  styleUrls: ['./searchMusics.component.scss']
})
export class SearchMusicsComponent implements OnInit {

  titleDeezer = '';
  tooltipTitleDeezer = '';
  musiquesDeezer = [];

  @ViewChild('searchInput') searchInput;

  loadingDeezer = false;

  isClassicSearch = false;

  @ViewChild('PaginatorPlaylists', {static: true}) paginator: MatPaginator;
  @ViewChild('PaginatorClassic', {static: true}) paginatorClassic: MatPaginator;

  displayedColumns: string[] = ['presence', 'cover', 'release', 'title', 'artist', 'album', 'duration', 'actions'];
  musiquesMatTable = new MatTableDataSource<any>(this.musiquesDeezer);

  folderName = '';

  isDownloading = '';

  downloadsOK = [];

  downloadsWaiting = [];

  selectionMusiquesDeezer;

  classicIndex = 0;
  classicLength = 0;

  lastDownloadWanted = 0;
  countLastDownloadWanted = 0;
  timeoutLastDownloadWanted;

  constructor(private searchMusicsService: SearchMusicsService,
              private dataPassService: DataPassService,
              private changeDetectorRef: ChangeDetectorRef,
              private iconRegistry: MatIconRegistry,
              private sanitizer: DomSanitizer,
              @Inject(MAT_BOTTOM_SHEET_DATA) private dataIn,
              private snackBar: MatSnackBar) {
    iconRegistry.addSvgIcon('play', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/play.svg'));
    iconRegistry.addSvgIcon('stop', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/stop.svg'));
    iconRegistry.addSvgIcon('close', sanitizer.bypassSecurityTrustResourceUrl('assets/icon/close.svg'));
    this.folderName = dataIn.folderName;
    const initialSelection = [];
    const allowMultiSelect = true;
    this.selectionMusiquesDeezer  = new SelectionModel<[]>(allowMultiSelect, initialSelection);
  }

  ngOnInit() {
    this.musiquesMatTable.paginator = this.paginator;

    // ID Playlist du Vendredi : 1478649355
    this.searchPlaylistDeezer('');
  }

  applyFilter(filterValue: string) {
    this.musiquesMatTable.filter = filterValue.trim().toLowerCase();
  }

  searchDeezer(search) {
    this.classicIndex = 0;
    this.classicLength = 0;
    this.paginatorClassic.pageIndex = this.classicIndex;
    if (search.indexOf('www.deezer.com') !== -1) {
      this.searchPlaylistDeezer(search);
    } else if (!search && search.trim().length === 0) {
      this.searchPlaylistDeezer('');
    } else {
      this.isClassicSearch = true;
      this.musiquesDeezer = [];
      this.titleDeezer = '';
      this.tooltipTitleDeezer = '';
      this.loadingDeezer = true;
      this.searchMusicsService.searchDeezer(search)
        .then(res => {
          console.log(res);
          this.loadingDeezer = false;
          // this.searchInput.nativeElement.value = '';
          this.titleDeezer = search + ' (recherche musique)';
          this.tooltipTitleDeezer = '';
          this.musiquesDeezer = res.data;
          this.classicLength = res.total;
          this.changeDetectorRef.detectChanges();
        }).catch(err => {
          console.log(err);
          this.loadingDeezer = false;
          this.changeDetectorRef.detectChanges();
        });
    }
  }

  searchDeezerEnter(e, search) {
    e.preventDefault();
    this.searchDeezer(search);
  }

  searchPlaylistDeezer(playlist, isAlbum=0, isTrack=0) {
    if (!playlist && playlist.trim().length === 0) {
      playlist = '1478649355';
    }
    this.musiquesDeezer = [];
    this.musiquesMatTable = new MatTableDataSource<any>(this.musiquesDeezer);
    this.musiquesMatTable.paginator = this.paginator;
    this.isClassicSearch = false;
    this.titleDeezer = '';
    this.tooltipTitleDeezer = '';
    this.loadingDeezer = true;
    let idPlaylist;
    if (isAlbum === 1) {
      idPlaylist = playlist;
    } else if (playlist.indexOf('/album/') !== -1) {
      const playlistArray = playlist.split('?')[0].split('/');
      idPlaylist = playlistArray[playlistArray.length - 1];
      isAlbum = 1;
    } else if (playlist.indexOf('/track/') !== -1) {
      const playlistArray = playlist.split('?')[0].split('/');
      idPlaylist = playlistArray[playlistArray.length - 1];
      isTrack = 1;
    } else {
      const albumArray = playlist.split('?')[0].split('/');
      idPlaylist = albumArray[albumArray.length - 1];
    }
    this.searchMusicsService.getPlaylistDeezer(idPlaylist, isAlbum, isTrack)
      .then(res => {
        console.log(res);
        this.loadingDeezer = false;
        // this.searchInput.nativeElement.value = '';
        if (isTrack === 1 && res) {
          this.titleDeezer = res[0].title + ' (track)';
          this.tooltipTitleDeezer = '';
          this.musiquesDeezer = res;
          this.musiquesMatTable = new MatTableDataSource<any>(this.musiquesDeezer);
          this.musiquesMatTable.paginator = this.paginator;
        }
        else if (res.tracks) {
          if (isAlbum === 1) {
            this.titleDeezer = res.title + ' - ' + res.artist.name + ' (album)';
            this.tooltipTitleDeezer = '';
            for (const dataTrack of res.tracks.data) {
              dataTrack['album'] = {
                cover: res.cover,
                cover_big: res.cover_big,
                cover_medium: res.cover_medium,
                cover_small: res.cover_small,
                cover_xl: res.cover_xl,
                id: res.id,
                title: res.title,
                tracklist: res.tracklist,
                type: res.type
              };
              dataTrack['album_extend'] = {
                label: res.label,
                release_date: res.release_date
              };
            }
          } else {
            this.titleDeezer = res.title + ' (playlist)';
            this.tooltipTitleDeezer = res.description + ' (' + res.creator.name + ')';
          }
          this.musiquesDeezer = res.tracks.data;
          this.musiquesMatTable = new MatTableDataSource<any>(this.musiquesDeezer);
          this.musiquesMatTable.paginator = this.paginator;
        }
        this.changeDetectorRef.detectChanges();
      }).catch(err => {
        console.log(err);
        this.loadingDeezer = false;
        this.changeDetectorRef.detectChanges();
      });
  }

  downloadMusic(musique, fromWatingList= false) {
    if (fromWatingList) {
      this.downloadsWaiting = this.downloadsWaiting.slice(1);
    }
    if (this.isDownloading === '') {
      this.isDownloading = musique.link;
      this.searchMusicsService.downloadMusicDeezer(musique.link, this.folderName)
        .then(res => {
          console.log(res);
          res.deezerData = musique;
          this.snackBar.open(`"${musique.title}" correctement ajouté`);
          this.isDownloading = '';
          this.dataPassService.searchMusics_result.push(res);
          this.downloadsOK.push(musique.link);
          this.changeDetectorRef.detectChanges();
          console.log('downloadsWaiting', this.downloadsWaiting);
          if (this.downloadsWaiting.length > 0) {
            this.downloadMusic(this.downloadsWaiting[0], true);
          }
        })
        .catch(err => {
          console.log(err);
          this.isDownloading = '';
          this.changeDetectorRef.detectChanges();
          if (this.downloadsWaiting.length > 0) {
            this.downloadMusic(this.downloadsWaiting[0], true);
          }
        });
    } else {
      this.downloadsWaiting.push(musique);
    }
  }

  downloadAudioFile(musique) {
    if (this.lastDownloadWanted === musique.id && this.countLastDownloadWanted > 3) {
      clearTimeout(this.timeoutLastDownloadWanted);
      this.lastDownloadWanted = 0;
      this.countLastDownloadWanted = 0;
      const musiqueWanted = this.dataPassService.searchMusics_result.find(item => item.deezerData.id === musique.id);
      if (musiqueWanted) {
        this.searchMusicsService.downloadAudioFile(this.folderName, musiqueWanted.name);
      }
    } else {
      this.lastDownloadWanted = musique.id;
      this.countLastDownloadWanted++;
      clearTimeout(this.timeoutLastDownloadWanted);
      this.timeoutLastDownloadWanted = setTimeout(() => {
        this.lastDownloadWanted = 0;
        this.countLastDownloadWanted = 0;
      }, 3000);
    }
  }

  isAllSelected() {
    const numSelected = this.selectionMusiquesDeezer.selected.length;
    const numRows = this.musiquesDeezer.length;
    console.log(numSelected);
    console.log(numRows);
    return numSelected === numRows;
  }

  masterToggle() {
    console.log('masterToggle');
    console.log('isAllSelected?', this.isAllSelected());
    this.isAllSelected() ?
      this.selectionMusiquesDeezer.clear() :
      this.musiquesDeezer.forEach(row => {
        if (!this.downloadsOK.includes(row.link)) {
          this.selectionMusiquesDeezer.select(row);
        }
      });
  }

  isInWaitingList(element) {
    return this.downloadsWaiting.find(e => e.link === element.link);
  }

  playExtraitAndReleaseDate(element) {
    this.searchMusicsService.playextrait(element.preview);
    if (!element.album_extend) {
      this.searchMusicsService.searchAlbumDeezer(element.album.id)
        .then(res => {
          element.album_extend = res;
          this.changeDetectorRef.detectChanges();
        });
    }
  }

  changePageClassic(e) {
    this.musiquesDeezer = [];
    this.loadingDeezer = true;
    this.searchMusicsService.searchDeezer(this.searchInput.nativeElement.value, e.pageIndex * e.pageSize)
      .then(res => {
        this.loadingDeezer = false;
        this.musiquesDeezer = res.data;
        this.changeDetectorRef.detectChanges();
      }).catch(err => {
        this.loadingDeezer = false;
        this.changeDetectorRef.detectChanges();
      });
  }
}
